module.exports = __webpack_public_path__ + "img/fast-forward.e155dde.png";